export default "__VITE_ASSET__285e454b__"